module.exports = __webpack_public_path__ + "media/images/panganight@3x_pc-897d96cc1f27d35693385df3a4a1f595.png";